import { styled } from 'styled-components'

export const BalanceWidgetContainer = styled.div`
  /* Container is invisible when empty, doesn't block clicks */
  &:empty {
    display: none;
  }

  /* When SDK injects content, the zoid container and iframe become full-screen overlays */
  & > div[id*='zoid-balance'],
  & > div[id*='zoid-balance'] > iframe {
    position: fixed !important;
    top: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    z-index: 9999 !important;
    width: 100vw !important;
    height: 100vh !important;
  }

  /* Ensure any iframe covers the full viewport */
  & > div > iframe {
    position: fixed !important;
    top: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    z-index: 10000 !important;
    width: 100vw !important;
    height: 100vh !important;
    border: none !important;
  }
`
